import getNumberedCopyName from '@/utils/general/getNumberedCopyName'

// Thin wrapper that fixes the base name to "<prefix> of <name>" and
// defers the "(N)" disambiguation to the shared helper -- same logic
// the AssumptionSets duplicate flow and the Marvin copy tool use, so
// numbering stays consistent across all three.
export const decideCopyName = (
  name: string,
  optionNames: string[],
  prefix: 'Copy' | 'Release' = 'Copy',
) => getNumberedCopyName(`${prefix} of ${name}`, optionNames)
